import * as React from "react";
import { SVGProps } from "react";
const SvgOpenIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 1024 1024"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M759.2 419.8 697.4 358 512 543.4 326.6 358l-61.8 61.8L512 667z" />
  </svg>
);
export default SvgOpenIcon;
